export default class Wave {

    constructor(id) {
        var W = {};

        /*========================================
        Utility
        ========================================*/

        W.rand = function (min, max) {
            if (!max) {
                var max = min;
                min = 0;
            }

            return Math.random() * (max - min) + min;
        };

        /*========================================
        Initialize
        ========================================*/

        W.init = function () {
            W.c = document.querySelector(id);
            W.ctx = W.c.getContext('2d');
            W.simplex = new SimplexNoise();
            W.events();
            W.reset();
            W.loop();
        };

        /*========================================
        Reset
        ========================================*/

        W.reset = function () {
            W.w = window.innerWidth;
            // W.h = window.innerHeight;
            W.h = 220;
            W.cx = W.w / 2;
            W.cy = W.h / 2;
            W.c.width = W.w;
            W.c.height = W.h;

            W.count = Math.floor(W.w / W.rand(15, 22)); // Wave frequency
            W.xoff = 0;
            W.xinc = 0.05;
            W.yoff = 0;
            W.yinc = 0.008; // Speed
            W.goff = 0;
            W.ginc = 0;
            W.y = W.h * 0.65;
            W.length = W.w + 0;
            W.amp = 50; // Wave height
        };

        /*========================================
        Event
        ========================================*/

        W.events = function () {
            window.addEventListener('resize', W.reset.bind(undefined));
        };

        /*========================================
        Wave
        ========================================*/

        W.wave = function (color, amp, height, comp) {
            W.ctx.beginPath();
            var sway = W.simplex.noise2D(W.goff, 0) * amp;

            for (var i = 0; i <= W.count; i++) {
                W.xoff += W.xinc;
                var x = W.cx - W.length / 2 + W.length / W.count * i;
                var y = height + W.simplex.noise2D(W.xoff, W.yoff) * amp + sway;
                W.ctx[i === 0 ? 'moveTo' : 'lineTo'](x, y);
            }

            W.ctx.lineTo(W.w, -W.h); // -W.h - Vertically reflection
            W.ctx.lineTo(0, -W.h); // -W.h - Vertically reflection
            W.ctx.closePath();
            W.ctx.fillStyle = color;

            if (comp) {
                W.ctx.globalCompositeOperation = comp;
            }

            W.ctx.fill();
        };

        /*========================================
        Loop
        ========================================*/

        W.loop = function () {
            requestAnimationFrame(W.loop);

            W.ctx.clearRect(0, 0, W.w, W.h);
            W.xoff = 0;

            W.wave("rgba(232, 71, 85, 0.2)", 30, W.h * .65, "screen");
            W.wave("rgba(250, 207, 158, 0.25)", 30, W.h * .65, "screen");

            // W.ctx.fillStyle = "#e8475500";

            // W.ctx.globalCompositeOperation = "darken";

            // W.ctx.fillRect(0, 0, W.w, W.h);

            W.yoff += W.yinc;
            W.goff += W.ginc;
        };

        /*========================================
        Start
        ========================================*/

        W.init();
    }
}